// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1_pHh","cls2":"RatingCard-cls2__C7 RatingCard-cls1_pHh","variant-corex":"RatingCard-variant-corex__Je"};